import { XferStorage } from '../../../shared/models/xfer.model';

export const LOCAL_STORAGE_ID = '000000000000000000000000';
export const LOCAL_STORAGE_LABEL = 'My Computer';
export const LOCAL_STORAGE = {
  label: LOCAL_STORAGE_LABEL,
  _id: LOCAL_STORAGE_ID,
  url: LOCAL_STORAGE_LABEL,
  kind: 'blob',
} as XferStorage;
